import React, { useContext } from "react";
import { AlphaVersion } from "./constant";
import { Trans, useTranslation } from "react-i18next";
import AppContext from "./AppContext";
import { ReactSVG } from "react-svg";

const AppLogo = () => {
  const { t } = useTranslation();
  const { darkMode } = useContext(AppContext);
  return (
    <>
      <img src="apollo_logo.svg" alt="LOGO" className="md:h-9 sm:h-7 h-5" />
      <div className="flex flex-col">
        <ReactSVG
          src="ApolloText.svg"
          className="md:h-6 h-3 flex items-center justify-center"
          beforeInjection={(svg) => {
            svg.setAttribute("style", `fill: ${darkMode ? "white" : "black"}`);
          }}
        />
        <div
          className={`flex justify-end md:text-[6px] text-[3px] font-medium gap-1 ${
            darkMode ? " text-neutral-500" : " text-neutral-700"
          }`}
        >
          {/* <img src="AlphaIcon.svg" alt="LOGO" className="md:h-2 h-1" /> */}
          {AlphaVersion}
        </div>
      </div>
      <div
        className={`flex md:text-xxs sm:text-xxxs text-[5px] text-start items-center md:h-9 sm:h-7 h-5 font-normal border-l pl-3
      ${darkMode ? " text-white border-white" : "text-black border-black"}`}
      >
        <Trans i18nKey="appLogo.description">{t("appLogo.description")}</Trans>
      </div>
    </>
  );
};

export default AppLogo;
